import { createSelector } from '@ngrx/store';
import { selectAllRequesters } from './entity-store-selectors';

const normalizeId = (id: string | null | undefined) => id?.toLowerCase() ?? null;

export function selectRequesterByRequestId(requestId: string) {
  const normalizedRequestId = normalizeId(requestId);
  return createSelector(selectAllRequesters, (requesters) => {
    return requesters.find((r) => normalizeId(r.requestId) === normalizedRequestId);
  });
}
